module.exports = __webpack_public_path__ + "img/l1-window.0fa2e368.png";